export const floatingMenu = {
  floatingMenuMenu: "Menu",
  floatingMenuHome: "Home",
  floatingMenuGames: "Games",
  floatingMenuSlots: "Slots",
  floatingMenuSports: "Sports",
  floatingMenuLottery: "Lottery",
  floatingMenuCasino: "Casino",
  floatingMenuFeed: "Feed",
  floatingMenuBingo: "Bingo",
  floatingMenuToPlay: "Play",
  floatingMenuCategories: "Categories",
  floatingMenuSeeAllGames: "Go to all games",
  floatingMenuSeeAllSports: "Go to all sports",
};
